module.exports = __webpack_public_path__ + "media/images/mypage/icon/black/ico_company-0ae12dcb3abda990d35c0e8bdc2e23c3.svg";